<p-dialog [(visible)]="displayDialog" [modal]="true" [closable]="true" (onHide)="closeDialog()" [style]="{width: '650px'}" [draggable]="false">
    <ng-template pTemplate="header">
      <div class="flex align-items-center">
        <i class="pi pi-info-circle" style="font-size: 2rem; margin-right: 0.5rem; color: #ff9800;"></i>
        <span class="font-bold text-lg">Template In Use</span>
      </div>
    </ng-template>
    
    <div class="p-fluid">
      <h3 class="text-primary">Esta plantilla se utiliza en los siguientes atributos:</h3>
      <p-table [value]="templateInuse" [paginator]="true" [rows]="5">
        <ng-template pTemplate="header">
          <tr>
            <th>ID Catalog</th>
            <th>Name Catalog</th>
            <th>ID Fascicle</th>
            <th>Name Fascicle</th>
            <th>Page Number</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item>
          <tr>
            <td>{{ item?.idCatalog }}</td>
            <td>{{ item?.nameCatalog }}</td>
            <td>{{ item?.idFascicle }}</td>
            <td>{{ item?.nameFascicle }}</td>
            <td>{{ item?.pageNumber }}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
    
    <ng-template pTemplate="footer">
      <div class="flex justify-content-end">
        <button pButton type="button" label="Close" icon="pi pi-times" (click)="closeDialog()" class="p-button-rounded p-button-danger"></button>
      </div>
    </ng-template>
  </p-dialog>